import { useQuery } from '@apollo/client';
import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AdvanceFormFooter, MainContentContainer } from 'components';
import { Bioparams } from 'models/bioparams';
import { FullAppointment } from 'models/fullAppointment';
import { FIND_LAST_APPOINTMENT_PATIENT_BY_ID } from 'services/graphql/queries/appointment/findLastAppointment';
import BiochemicalParametersForm from './form';

function BiochemicalParameters() {
  const history = useHistory();

  const submitButtonRef = useRef<HTMLButtonElement>(null);

  const [lastBioparams, setLastBioparams] = useState<Bioparams | undefined>();
  const patientId = Number(localStorage.getItem('patientId'));
  const { data, loading } = useQuery<{
    getLastPatientAppointment: FullAppointment;
  }>(FIND_LAST_APPOINTMENT_PATIENT_BY_ID, {
    variables: {
      patientId
    },
    fetchPolicy: 'no-cache'
  });

  function lastAppointmentSymptoms() {
    setLastBioparams(data?.getLastPatientAppointment.bioParams);
  }

  const [hasLastAppointment, setHasLastAppointment] = useState(false);

  useEffect(() => {
    if (data?.getLastPatientAppointment?.bioParams) setHasLastAppointment(true);
  }, [data, loading]);

  function submitForm() {
    submitButtonRef.current?.click();
  }

  return (
    <Box display="flex" flexDirection="column" width="60%">
      <MainContentContainer
        headerTitle="5. Parâmetros Bioquímicos"
        useDataFromLastAppointmentSwitch={{
          action: lastAppointmentSymptoms,
          hasLastAppointment: hasLastAppointment
        }}
      >
        <Box
          padding="25px 20px"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          width="100%"
        >
          <BiochemicalParametersForm
            lastBioparams={lastBioparams}
            ref={submitButtonRef}
          />
        </Box>
      </MainContentContainer>
      <Box alignSelf="flex-end" marginTop="-6%">
        <AdvanceFormFooter
          back={() => history.push('/home/life-quality-scale')}
          action={() => submitForm()}
        />
      </Box>
    </Box>
  );
}

export { BiochemicalParameters };
